import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { cloneDeep, isEmpty } from "lodash";
import { Ttraining, TTrainingType } from "../../shared/types/training.type";
import { TtrainingKeyParameter } from "../../shared/types/trainingKeyParameter.type";
import { TgroupKeyParam } from "../../shared/utils/comparaison";
import { TtrainingKeyParameterItem } from "../../shared/types/TrainingKeyParameterItem.type";
import { TkeyParamLayout } from "../../shared/types/computedKeyParam.type";
import { Ttrack } from "../../shared/types/tracks.type";

export type TComparaisonFilters = {
    startDate: any,
    endDate: any,
    selectedTracks: Ttrack[],
    selectedTrainingTypes: TTrainingType[]
}

type initalStateType = {
    open: boolean,
    checkedExams: Ttraining[],
    data?: TtrainingKeyParameter | null,
    categories: TgroupKeyParam[],
    allCategories: TkeyParamLayout[],
    options?: string,
    filters: TComparaisonFilters,
    launchComparaison: boolean
}

const initialState: initalStateType = {
    open: false,
    launchComparaison: false,
    checkedExams: [],
    categories: [],
    allCategories: [],
    options: '',
    filters: {
        startDate: undefined,
        endDate: undefined,
        selectedTracks: [],
        selectedTrainingTypes: []
    }
}

export const comparaisonReducer = createSlice({
    name: 'comparaison',
    initialState,
    reducers: {
        openModal: (state, action: PayloadAction<boolean>) => {
            state.open = action.payload
        },
        runComparaison: (state, action: PayloadAction<boolean>) => {
            state.launchComparaison = action.payload
        },
        setData: (state, action: PayloadAction<TtrainingKeyParameter | null>) => {
            state.data = action.payload
        },
        setCategories: (state, action: PayloadAction<TgroupKeyParam[]>) => {
            state.categories = action.payload
        },
        resetCheckedExam: (state) => {
            state.checkedExams = []
        },
        updateCheckExam: (state, action: PayloadAction<{ checked: boolean, exam: Ttraining }>) => {
            let copy = cloneDeep(state.checkedExams)
            if (action.payload.checked) {
                state.checkedExams = isEmpty(copy) ? [action.payload.exam] : [...copy, action.payload.exam]
            } else {
                let index = copy.findIndex(e => e.id === action.payload.exam.id)
                if (index !== -1) {

                    copy.splice(index, 1)
                    state.checkedExams = copy
                }
            }
        },
        setDataItems: (state, action: PayloadAction<TtrainingKeyParameterItem[]>) => {
            let newState = cloneDeep(state.data)
            if (!newState) return
            newState.items = action.payload
            state.data = newState
            if (isEmpty(newState.items)) {
                state.categories = []
            }
        },
        setAllKeyLayouts: (state, action: PayloadAction<TkeyParamLayout[]>) => {
            state.allCategories = action.payload
        },
        setOptionQuery: (state, action: PayloadAction<string | undefined>) => {
            state.options = action.payload
        },
        updateFilters: (state, action: PayloadAction<TComparaisonFilters>) => {
            state.filters = action.payload
        },
        resetFilters: (state) => {
            state.filters = {
                startDate: undefined,
                endDate: undefined,
                selectedTracks: [],
                selectedTrainingTypes: []
            }
        },
        resetAllParams: () => {
            return initialState
        }
    }
})
export const { runComparaison,resetFilters, updateFilters, resetAllParams, setOptionQuery, openModal, updateCheckExam, setData, setCategories, setDataItems, resetCheckedExam, setAllKeyLayouts } = comparaisonReducer.actions
export default comparaisonReducer.reducer